import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function PublicLayout({ children, overlayNav = false, padTop = true }) {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <Navbar overlay={overlayNav} />
      <main className={padTop && !overlayNav ? "pt-20" : ""}>{children}</main>
      <Footer />
    </div>
  );
}
